import { render, staticRenderFns } from "./ShiftTypes.vue?vue&type=template&id=894517e8"
import script from "./ShiftTypes.vue?vue&type=script&lang=ts"
export * from "./ShiftTypes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports